import { IconButton, UIHeading2, UIHeading4, Body1, Caption } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './styles.css';
import { UserCardSwitcher, UserCardSwitcherContent } from '../UserCardSwitcher';
import { useUserCardTabs } from '../../../hooks/userCard';
import { UserCardBlockChatContainer } from '../../../containers/UserCardBlockChatContainer';

type TUserCardLayout = {
  companionName?: string | null;
  companionTypeName: string;
  companionIdStr?: string;
  handleClickClose: () => void;
  avatar: React.ReactNode;
  actions: React.ReactNode | null;
  updateChatFiles: () => void;
};

export const UserCardLayout: React.FC<TUserCardLayout> = ({
  companionName,
  companionTypeName,
  companionIdStr,
  handleClickClose,
  avatar,
  actions,
  updateChatFiles,
}) => {
  const scrollContainer = React.useRef<HTMLImageElement>(null);
  const [isVisibleFixedHeader, setVisibilityFixedHeader] = React.useState<boolean>(false);
  const { tabs, activeTab, setActiveTab } = useUserCardTabs();

  const handleScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

      setVisibilityFixedHeader(scrollTop > 160);

      if (scrollHeight === scrollTop + offsetHeight) {
        updateChatFiles();
      }
    },
    [updateChatFiles],
  );

  return (
    <div className={styles['container']} data-testid="UserCardLayout">
      <div className={styles['header']}>
        {isVisibleFixedHeader && (
          <div className={styles['title__fixed']}>
            <div data-testid="UserCardMobileLayoutName">
              <UIHeading4 color="text-primary-default">{companionName || companionIdStr}</UIHeading4>
            </div>
            <div data-testid="UserCardMobileLayoutTypeName">
              <Caption color="text-secondary-default">{companionTypeName}</Caption>
            </div>
          </div>
        )}
        <IconButton icon={<IconActionClose12 />} onClick={handleClickClose} data-testid="ButtonClose" />
      </div>
      <div className={styles['scroll']} onScroll={handleScroll} ref={scrollContainer}>
        <div className={styles['content']}>
          {avatar}
          <div className={styles['title']}>
            <div data-testid="UserCardMobileLayoutName">
              <UIHeading2 color="text-primary-default">{companionName || companionIdStr}</UIHeading2>
            </div>
            <div data-testid="UserCardMobileLayoutTypeName">
              <Body1 color="text-secondary-default">{companionTypeName}</Body1>
            </div>
          </div>

          {actions}

          {activeTab && (
            <>
              <UserCardSwitcher tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

              <UserCardSwitcherContent activeTab={activeTab} />
            </>
          )}

          <UserCardBlockChatContainer />
        </div>
      </div>
    </div>
  );
};
